var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 8,
    fill: "#EEF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7417 37.3C75.1417 33.7 72.5417 40.9 68.6417 40.9C64.7417 40.9 66.0417 37.3 66.0417 36C63.4417 36 60.8417 40.9 59.5417 43.3C58.2417 43.3 58.2417 37.2 58.2417 37.2C58.2417 37.2 51.7417 37.2 47.9417 49.4C44.1417 61.8 52.7417 73.6 57.7417 79C59.4417 89.5 64.6417 102.9 80.3417 102.9C98.5417 102.9 101.342 82.5 101.442 70.4C109.842 51.8 97.7417 40.8 86.7417 37.3Z",
    fill: "#B1CCF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 149C23 126.909 40.9086 109 63 109H97C119.091 109 137 126.909 137 149V160H23V149Z",
    fill: "#B1CCF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 109C68.2034 108 67.3071 99 67.3071 91H92.7072C91.8475 99.5 91.322 108 95 109H64Z",
    fill: "#B1CCF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProfile);
export default __webpack_public_path__ + "static/media/no_profile.d11de5d32612dd9bc23631afd6278abf.svg";
export { ForwardRef as ReactComponent };